async function bondFixedExpiryTellerCreate(contracts, contractName, underlying, expiry, amount) {
  const teller = contracts.getContractByName(contractName);
  return await teller.create(underlying, expiry, amount);
}

async function bondFixedExpiryTellerRedeem(contracts, contractName, token, amount) {
  const teller = contracts.getContractByName(contractName);
  return await teller.redeem(token, amount);
}

async function bondFixedExpiryTellerDeploy(contracts, contractName, underlying, expiry) {
  const teller = contracts.getContractByName(contractName);
  return await teller.deploy(underlying, expiry);
}

async function bondFixedExpiryTellerGetTokenId(contracts, contractName, underlying, expiry) {
  const teller = contracts.getContractByName(contractName);
  return await teller.getTokenId(underlying, expiry);
}

async function  bondFixedExpiryTellerGetTokenNameAndSymbol(contracts, contractName, tokenId) {
  const teller = contracts.getContractByName(contractName);
  return await teller.getTokenNameAndSymbol(tokenId);
}

module.exports = {
  bondFixedExpiryTellerCreate,
  bondFixedExpiryTellerRedeem,
  bondFixedExpiryTellerDeploy,
  bondFixedExpiryTellerGetTokenId,
  bondFixedExpiryTellerGetTokenNameAndSymbol
};
